<div class="header">
    <ng-content select="vsf-layout-header"></ng-content>
</div>
<div class="content py-4 sm:py-0 bg-main">
    <ng-content></ng-content>
</div>
<div class="footer">
    <ng-content select="vsf-layout-footer"></ng-content>
</div>
<vsf-cookie-banner></vsf-cookie-banner>
@if (showScrollTop) {
    <button
        (click)="scrollToTop()"
        aria-label="Scroll to top"
        class="
            fixed
            bottom-16 lg:bottom-8
            left-8 lg:left-8
            z-[100]

            flex items-center justify-center
            w-12 h-12 rounded-full

            scroll-top-button

            transition-colors duration-200
        "
        >
        <i class="pi pi-arrow-up text-lg"></i>
    </button>
}
